export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      linkedCmsMst: {
        linkedCmsMstId: 1,
        linkedCmsMstUuid: 'linkedcms001',
        linkedCmsName: 'レストラン予約CMS',
        linkedCmsCode: 'cms-xxxxx-xxxxx-xxxxx',
        linkedCmsUrl: 'https://xxx.xxx.xxx',
        linkedCmsStatus: 1
      }
    }
  }
}